import { Component, OnInit } from '@angular/core';
import {TableHeaderService} from '../../../resources/services/table-header.service';
import {FormService} from '../../../resources/services/form.service';
import {ActivatedRoute, Router, Routes} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Location} from '@angular/common';
import {AccountService} from '../../../resources/services/account.service';
import {AccountViewRoutes} from "./account-view.routes";
import {Subscription} from "rxjs";

@Component({
  selector: 'account-view',
  templateUrl: './account-view.component.html'
})
export class AccountViewComponent implements OnInit {

  id: any;
  item: any;
  routes: Routes = AccountViewRoutes;
  paramsChange: Subscription;
  initial: string;

  constructor(private tableHeaderService: TableHeaderService,
              private _formService: FormService,
              private _route: ActivatedRoute,
              private _toastr: ToastrService,
              private _location: Location,
              private _router: Router,
              private _modelService: AccountService) {
    this.paramsChange = this._route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit(): void {
    this.get();
  }

  ngOnDestroy() {
    this.paramsChange.unsubscribe();
  }

  get(): void {
    this._modelService.get({id: this.id})
      .subscribe((res: any) => {
          this.item = res;
          this.initial = res.email;
        },
        err => {
        }
      );
  }

}
